var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotificationActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.427 26C20.427 27.8937 18.8922 29.4286 17 29.4286C15.1079 29.4286 13.5731 27.8937 13.5731 26H20.427ZM28.3362 21.1939C28.4067 21.2681 28.4745 21.3393 28.5388 21.4084C28.8602 21.7534 29.0027 22.167 29 22.5714C28.9947 23.45 28.3047 24.2857 27.2804 24.2857H6.71968C5.69539 24.2857 5.00593 23.45 5.00004 22.5714C4.99736 22.167 5.13986 21.7539 5.46129 21.4084C5.52557 21.3393 5.59334 21.2681 5.6639 21.1939C6.72939 20.0737 8.43289 18.2828 8.43289 13.1429C8.43289 8.98036 11.3515 5.64821 15.2868 4.83071V3.71429C15.2868 2.76768 16.054 2 17 2C17.9461 2 18.7133 2.76768 18.7133 3.71429V4.83071C19.9854 5.09499 21.1513 5.62204 22.1468 6.35498C20.3032 7.09144 19.0007 8.89361 19.0007 11C19.0007 13.7614 21.2393 16 24.0007 16C24.6088 16 25.1915 15.8914 25.7306 15.6927C26.182 18.9292 27.4699 20.2832 28.3362 21.1939Z",
    fill: "#BDCCD4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 11,
    r: 3,
    fill: "#4FFFB0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationActiveIcon);
export default __webpack_public_path__ + "static/media/NotificationActiveIcon.c184ef16914bc03030a8c25550065dd5.svg";
export { ForwardRef as ReactComponent };